const { findOrCreateStatuses, hedmCustomFieldPath, hedmModelCodeMappings, hedmCodeMappings } = require('../constants/common');
const { getClientIp } = require('request-ip');

const getDateString = (date) => {
    if (typeof date === 'string') {
        return date;
    } else if (date instanceof Date) {
        const year = '' + date.getFullYear();
        let month = '' + (date.getMonth() + 1);
        let day = '' + date.getDate();

        if (month.length < 2) {
            month = '0' + month;
        }

        if (day.length < 2) {
            day = '0' + day;
        }

        return `${year}-${month}-${day}`;
    } else {
        return null;
    }
};

const isPersonError = (status) => {
    const { createError, unexpectedError, erpError } = findOrCreateStatuses;
    return [createError, unexpectedError, erpError].includes(status);
}

const getIpAddress = (req) => {
    let ipAddress = getClientIp(req);
    ipAddress = ipAddress ? ipAddress.replace('::ffff:', '') : ipAddress; // ipv6 to ipv4
    ipAddress = ipAddress === '::1' ? '127.0.0.1' : ipAddress; // localhost
    return ipAddress;
};

const getCodeFieldInfoForQuestion = (question) => {
    let codeField;

    if (question.eedmDestinationAttribute) {
        if (question.eedmDestinationAttribute === hedmCustomFieldPath) {
            const model = question.possibleValues?.model || question.filteredSearch?.model;
            if (model) {
                codeField = hedmModelCodeMappings[model];
            }
        } else {
            codeField = hedmCodeMappings[question.eedmDestinationAttribute];
        }
    }

    return codeField;
};


module.exports = {
    getDateString,
    isPersonError,
    getIpAddress,
    getCodeFieldInfoForQuestion
};
